<template>
  <div>
    <div class="ds-appbar">
      <div class="ds-appbar-tabs" id="appBarTabs">
        <div class="user TA_delay" dstype="a-barLoginBox">
          <div class="avatar TA"><img src="@/assets/images/avatar.png"></div>
          <p class="TA">未登录</p>
        </div>
        <ul class="tools">
          <li><a href="javascript:void(0);" @click="goCart" id="rtoolbar_cart" class="cart TA_delay"><span
                class="iconfont"></span><span class="tit">购物车</span><i id="rtoobar_cart_count" class="new_msg"
                style="display:none;"></i></a></li>
          <a href="javascript:void(0);" id="qrcode" class="qrcode TA_delay"><span class="iconfont"></span>
            <span class="tit-box">
              手机购物<br>
              <img src="@/assets/images/mobile_qrcode.jpg" width="110" height="110">
              <em class="tips_arrow"></em>
            </span>
          </a>

          </li>
          <li><a href="javascript:void(0);" @click="goTop" id="gotop" class="gotop TA_delay"
              style="position: fixed;bottom: 0"><span class="iconfont"></span><span class="tit">顶部</span></a></li>
        </ul>
        <div class="content-box" id="content-cart">
          <div class="top">
            <h3>我的购物车</h3>
            <a href="javascript:void(0);" class="close iconfont" title="隐藏"></a>
          </div>
          <div id="rtoolbar_cartlist"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import '@/assets/styles/common.css'
  import {
    getUserInfo
  } from '@/api/user.js'
  export default {
    name: 'Bar',
    data() {
      return {
        user: {}
      }
    },
    mounted() {
      var that = this
      getUserInfo().then((res) => {
        if (res) {
          that.user = res.data
        }
      })
      this.$nextTick(function () {
        //动画显示边条内容区域
        $(function () {
          $(".close").click(function () {
            close_bar();
          });
          // 右侧bar用户信息
          $('div[dstype="a-barUserInfo"]').click(function () {
            $('div[dstype="barUserInfo"]').toggle();
          });
          // 右侧bar登录
          $('div[dstype="a-barLoginBox"]').click(function () {
            that.login_dialog();
          });

        });
      })
    },
    methods: {
      login_dialog() {
        if (
          this.$cookie.get('login_status') &&
          this.$cookie.get('login_status') != ''
        ) {
          this.$router.push('/user/center')
        } else {
          this.$router.push('/login')
        }
      },
      goTop() {
        this.$nextTick(function () {
          $('html,body').animate({
            scrollTop: '0px'
          }, 500)
        })
      },
      goCart() {

        if (
          this.$cookie.get('login_status') &&
          this.$cookie.get('login_status') != ''
        ) {
          if (this.user.status == 1) {
            this.$router.push('/cart')
          } else {
            this.$dialog.error('请联系管理员审核')
          }

        } else {
          this.$router.push('/login')
        }
      }
    },
  }
</script>

<style scoped>

</style>
